// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LanguagesPopupContainer_QFqUQ {
    height: 100vh;
    width: 100vw;
    z-index: 99999;
    position: fixed;
    top: 0;
    left: 0;

    .containerLanguages_RWxoi {
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        background-color: var(--f5-background);
    }

    .content_NZNyP {
        background-color: var(--white-background);
        box-sizing: border-box;
        border-radius: 8px;
        width: 95%;
        margin: 10px auto;
        padding: 10px;
        overflow: scroll;
        height: calc(100vh - 67px);
        max-height: calc(100vh - 67px);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: space-between;
        >div{
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 20px;
            cursor: pointer;
            svg{
                height: 25px;
                width: 25px;
                border-radius: 10px;
            }
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/LanguagesPopup/LanguagesPopup.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;;IAEP;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,sCAAsC;IAC1C;;IAEA;QACI,yCAAyC;QACzC,sBAAsB;QACtB,kBAAkB;QAClB,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,gBAAgB;QAChB,0BAA0B;QAC1B,8BAA8B;QAC9B,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,8BAA8B;QAC9B;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,eAAe;YACf,eAAe;YACf;gBACI,YAAY;gBACZ,WAAW;gBACX,mBAAmB;YACvB;QACJ;IACJ;AACJ","sourcesContent":[".LanguagesPopupContainer {\n    height: 100vh;\n    width: 100vw;\n    z-index: 99999;\n    position: fixed;\n    top: 0;\n    left: 0;\n\n    .containerLanguages {\n        display: flex;\n        flex-direction: column;\n        overflow-y: auto;\n        background-color: var(--f5-background);\n    }\n\n    .content {\n        background-color: var(--white-background);\n        box-sizing: border-box;\n        border-radius: 8px;\n        width: 95%;\n        margin: 10px auto;\n        padding: 10px;\n        overflow: scroll;\n        height: calc(100vh - 67px);\n        max-height: calc(100vh - 67px);\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        justify-content: space-between;\n        >div{\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            font-size: 20px;\n            cursor: pointer;\n            svg{\n                height: 25px;\n                width: 25px;\n                border-radius: 10px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LanguagesPopupContainer": `LanguagesPopupContainer_QFqUQ`,
	"containerLanguages": `containerLanguages_RWxoi`,
	"content": `content_NZNyP`
};
export default ___CSS_LOADER_EXPORT___;
